import React, { useState, useEffect } from 'react';
import { FormGroup } from 'src/components/ui';
import InputMask from 'react-input-mask';
import { useDebouncedEffect } from '../../hooks/useDebounceEffect';
import useTestId from '../../hooks/useTestId';

function msToHHMM(ms) {
  if (ms == null || typeof ms !== 'number' || isNaN(ms)) return '';
  const totalMinutes = Math.floor(ms / 60000);
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;
  return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
}

export default function DurationInput({
  id,
  required,
  disabled,
  readonly,
  autofocus,
  onChange: onChangeForm,
  formData,
  fieldPathId: { $id, path },
  schema: { title },
}) {
  const [current, setCurrent] = useState(() => msToHHMM(formData));
  const testIdProps = useTestId($id);

  useDebouncedEffect(
    () => {
      if (current && current.length === 5 && !current.includes('_')) {
        const ms = convertToMs(current);
        if (!isNaN(ms) && ms !== formData) {
          onChangeForm(ms, path);
        }
      }
    },
    [current],
    450
  );

  useEffect(() => setCurrent(msToHHMM(formData)), [formData]);

  const startWithTwo = current?.[0] === '2';

  const mask = {
    H: '[0-2]',
    h: startWithTwo ? '[0-3]' : '[0-9]',
    M: '[0-5]',
    m: '[0-9]',
  };

  return (
    <FormGroup>
      {title.trim() ? (
        <label className="control-label" htmlFor={$id}>
          {title}
          {required ? <span className="required">*</span> : null}
        </label>
      ) : null}
      <InputMask
        mask="Hh:Mm"
        formatChars={mask}
        maskChar="_"
        disabled={disabled}
        className="form-control"
        required={required}
        value={current || ''}
        onChange={e => setCurrent(e.target.value)}
        readOnly={readonly}
        autoFocus={autofocus}
        id={$id}
        {...testIdProps}
      />
    </FormGroup>
  );
}

function convertToMs(hhMM) {
  const [hours, minutes] = hhMM.split(':').map(v => parseInt(v, 10));
  return hours * 60 * 60 * 1000 + minutes * 60 * 1000;
}
